import React, { PropTypes } from 'react';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router';

class ContactList extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         nameString: '',
         mobileString: '',
         localContacts: []
      };
   }

   componentWillReceiveProps(nextProps) {
      this.setState({
         localContacts: nextProps.contacts
      });
   }

   filterOnName = (e) => {
      let searchString = e.target.value;
      this.setState({
         nameString: searchString,
         mobileString: ''
      });
      let filtered = this.props.contacts.filter((c) => {
         return c.name.toLowerCase().indexOf(searchString.toLowerCase()) > -1;
      });
      this.setState({
         localContacts: filtered
      });
   };
   filterOnMobile = (e) => {
      let searchString = e.target.value;
      this.setState({
         nameString: '',
         mobileString: searchString
      });
      let filtered = this.props.contacts.filter((c) => {
         return c.mobile ? c.mobile.indexOf(searchString) > -1 : false;
      });
      this.setState({
         localContacts: filtered
      });
   };

   render() {
      const { localContacts } = this.state;
      return (
         <Table striped bordered condensed hover >
            <thead>
            <tr>
               <th>Name</th>
               <th>Mobile</th>
               <th>Contact Type</th>
               <th>##</th>
            </tr>
            <tr>
               <th>
                  <input type="text" value={this.state.nameString} onChange={this.filterOnName} />
               </th>
               <th>
                  <input type="text" value={this.state.mobileString} onChange={this.filterOnMobile} />
               </th>
               <th>
                  &nbsp;
               </th>
               <th>
                  &nbsp;
               </th>
            </tr>

            </thead>
            <tbody>
            {localContacts.map((contact) => (
               <tr key={contact.id} >
                  <td>{contact.name}</td>
                  <td>{contact.mobile}</td>
                  <td>{contact.contact_type}</td>
                  <td>
                     <Link to={`/contact/detail/${contact.id}`} >Detail</Link>
                  </td>
               </tr>
            ))}
            </tbody>
         </Table>
      );
   }
}

ContactList.propTypes = {
   contacts: PropTypes.array.isRequired
};

export default ContactList;



/** WEBPACK FOOTER **
 ** ./src/components/Contact/ContactList.js
 **/